import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export const ServiceBusinessesHero = () => {
  return (
    <section className="relative min-h-[90vh] flex items-center">
      <div className="absolute inset-0 bg-gradient-to-r from-blue-900 via-blue-800 to-blue-700" />
      <div 
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}
      />
      <div className="max-w-7xl mx-auto px-4 relative z-10">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="text-white space-y-8">
            <h1 className="text-5xl font-bold leading-tight">
              Transform Your <span className="text-blue-300">Service Business</span> Into a Digital Success Story
            </h1>
            <p className="text-xl text-blue-100 leading-relaxed">
              Unlock your business potential with cutting-edge digital solutions designed 
              specifically for service-based companies. From client acquisition to 
              operational excellence, we're your partner in digital transformation.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Link to="/contact">
                <Button size="lg" className="bg-white text-blue-900 hover:bg-blue-50">
                  Start Your Journey
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Button>
              </Link>
            </div>
          </div>
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-blue-500/30 to-blue-300/30 rounded-3xl transform rotate-3" />
            <div className="absolute inset-0 bg-gradient-to-l from-blue-500/30 to-blue-300/30 rounded-3xl transform -rotate-3" />
            <div className="relative bg-gradient-to-br from-blue-600 to-blue-400 p-8 rounded-3xl shadow-2xl">
              <div className="grid grid-cols-2 gap-6">
                {[
                  { number: "10+", label: "Businesses Transformed" },
                  { number: "25%", label: "Average Growth" },
                  { number: "15%", label: "Cost Reduction" },
                  { number: "24/7", label: "Support Available" }
                ].map((stat, index) => (
                  <div key={index} className="text-center p-4 bg-white/10 rounded-xl backdrop-blur-sm">
                    <div className="text-3xl font-bold text-white mb-2">{stat.number}</div>
                    <div className="text-sm text-blue-100">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};